/* GA4 dataLayer — Brandon Blackwood. Pushes GA4 events to window.dataLayer for GTM.
   Server context: window.BB_GA4 (layout/theme.liquid). Per-item data: data-ga4-item on
   .product-card (ga4-item.liquid) and #bb-ga4-view-item on the PDP (product-section.liquid). */
(function () {
  'use strict';

  var CONFIG = window.BB_GA4 || {};
  var CURRENCY = CONFIG.currency || 'USD';
  window.dataLayer = window.dataLayer || [];

  function push(o) {
    window.dataLayer.push(o);
  }
  // Clear ecommerce before each push so items don't leak between events.
  function pushEcommerce(event, ecommerce) {
    push({ ecommerce: null });
    push({ event: event, ecommerce: ecommerce });
  }
  function txt(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }
  function round2(n) {
    return Math.round((Number(n) || 0) * 100) / 100;
  }
  function handleize(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function closestA(e) {
    return e.target.closest && e.target.closest('a[href]');
  }
  function nodeIndex(nodes, el) {
    var i = Array.prototype.indexOf.call(nodes, el);
    return i < 0 ? 1 : i + 1;
  }

  // Single delegated click listener; feature handlers register via onClick.
  // try/catch per handler preserves the error isolation that separate listeners gave us
  // (one handler throwing must not stop the others from running).
  var clickHandlers = [];
  function onClick(fn) {
    clickHandlers.push(fn);
  }
  document.addEventListener(
    'click',
    function (e) {
      for (var i = 0; i < clickHandlers.length; i++) {
        try {
          clickHandlers[i](e);
        } catch (err) {}
      }
    },
    true,
  );

  // Filter/sort state only — strip page params so scroll/pagination does not look like a new list.
  function listFilterKey() {
    try {
      var u = new URL(window.location.href);
      ['page', 'pg', 'p', 'page_num'].forEach(function (k) {
        u.searchParams.delete(k);
      });
      return u.pathname + u.search;
    } catch (e) {
      return location.pathname + location.search;
    }
  }

  // view_item_list impressions: only products actually on screen. Already reported
  // product ids are remembered per list + filter, so scrolling back does not re-fire.
  // A filter/sort URL change starts a fresh set. Page params are ignored, so the
  // next page of a collection still counts as the same list.
  var seenImpressions = {};
  var impressionIO = null;
  var watchedImpressions = [];
  var impressionFlushTimer = 0;
  var impressionSliderWaits = 0;

  function impressionKey(ctx) {
    return (
      (ctx && ctx.id ? ctx.id : '') +
      '|' +
      (ctx && ctx.name ? ctx.name : '') +
      '|' +
      listFilterKey()
    );
  }

  function elementIsVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var slider = el.closest && el.closest('.products-list__content, .swiper, .slick-slider');
    if (
      slider &&
      !slider.classList.contains('swiper-initialized') &&
      !slider.classList.contains('swiper-container-initialized') &&
      !slider.classList.contains('slick-initialized')
    ) {
      return false;
    }
    var slide = el.closest && el.closest('.swiper-slide, .slick-slide');
    var carouselSlide = false;
    if (slide) {
      // Swiper/Slick already decide which slides are in the frame, including the
      // ones cut off at the left and right edges.
      carouselSlide =
        slide.classList.contains('swiper-slide-visible') ||
        slide.classList.contains('slick-active');
      var swiperRoot = slide.closest('.swiper-initialized, .swiper-container-initialized');
      if (
        swiperRoot &&
        swiperRoot.querySelector('.swiper-slide-visible') &&
        !slide.classList.contains('swiper-slide-visible')
      ) {
        return false;
      }
      if (slide.closest('.slick-initialized') && !slide.classList.contains('slick-active')) {
        return false;
      }
    }
    var target = el.getBoundingClientRect();
    // Ignore shells Boost inserts before the grid has laid out.
    if (target.width < 120 || target.height < 120) return false;
    var top = target.top;
    var left = target.left;
    var bottom = target.bottom;
    var right = target.right;
    // Clip to the carousel window. Overflow-hidden slides still have a viewport rect.
    var clip = el.closest && el.closest('.swiper, .slick-list');
    if (clip && clip.getBoundingClientRect) {
      var box = clip.getBoundingClientRect();
      top = Math.max(top, box.top);
      left = Math.max(left, box.left);
      bottom = Math.min(bottom, box.bottom);
      right = Math.min(right, box.right);
    }
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var vw = window.innerWidth || document.documentElement.clientWidth || 0;
    if (!vh || !vw) return false;
    top = Math.max(top, 0);
    left = Math.max(left, 0);
    bottom = Math.min(bottom, vh);
    right = Math.min(right, vw);
    var visW = right - left;
    var visH = bottom - top;
    if (visW <= 0 || visH <= 0) return false;
    // Grids still need half the card on screen. A carousel slide Swiper is showing
    // counts even when the edge of it is cut off.
    if (!carouselSlide && visW < target.width * 0.5) return false;
    return visH >= Math.min(target.height, vh) * 0.5;
  }

  function pushVisibleList(ctx, items) {
    if (!ctx || !items || !items.length) return;
    var bucketKey = impressionKey(ctx);
    var seen = seenImpressions[bucketKey] || (seenImpressions[bucketKey] = {});
    var fresh = [];
    for (var i = 0; i < items.length; i++) {
      var id = String(items[i].item_id || '');
      if (!id || seen[id]) continue;
      seen[id] = 1;
      fresh.push(items[i]);
    }
    if (!fresh.length) return;
    fresh.sort(function (a, b) {
      return (a.index || 0) - (b.index || 0);
    });
    pushEcommerce('view_item_list', {
      item_list_id: ctx.id,
      item_list_name: ctx.name,
      currency: CURRENCY,
      items: fresh,
    });
  }

  // One scroll or swipe can reveal several products a few frames apart.
  // Hold them until the gesture settles, then send every new one in a single event.
  function scheduleImpressionFlush() {
    clearTimeout(impressionFlushTimer);
    impressionFlushTimer = setTimeout(flushVisibleImpressions, 320);
  }

  function markVisiblePending() {
    var found = false;
    for (var i = 0; i < watchedImpressions.length; i++) {
      var el = watchedImpressions[i];
      if (!el || el.__bbImpressionDone || el.__bbImpressionPending) continue;
      if (!elementIsVisible(el)) continue;
      el.__bbImpressionPending = true;
      found = true;
    }
    return found;
  }

  function sliderStillStarting(el) {
    var slider = el.closest && el.closest('.products-list__content, .swiper, .slick-slider');
    if (!slider) return false;
    return (
      !slider.classList.contains('swiper-initialized') &&
      !slider.classList.contains('swiper-container-initialized') &&
      !slider.classList.contains('slick-initialized')
    );
  }

  function flushVisibleImpressions() {
    var waitingForSlider = false;
    for (var w = 0; w < watchedImpressions.length; w++) {
      var watched = watchedImpressions[w];
      if (watched && !watched.__bbImpressionDone && sliderStillStarting(watched))
        waitingForSlider = true;
    }
    if (waitingForSlider && impressionSliderWaits < 20) {
      impressionSliderWaits += 1;
      scheduleImpressionFlush();
    }
    markVisiblePending();
    var groups = {};
    var order = [];
    for (var i = 0; i < watchedImpressions.length; i++) {
      var el = watchedImpressions[i];
      if (!el || el.__bbImpressionDone || !el.__bbImpressionPending || !el.__bbBuildImpression)
        continue;
      var item;
      try {
        item = el.__bbBuildImpression(el);
      } catch (e) {
        el.__bbImpressionPending = false;
        continue;
      }
      if (!item || item.item_id == null || item.item_id === '') {
        el.__bbImpressionPending = false;
        continue;
      }
      el.__bbImpressionDone = true;
      el.__bbImpressionPending = false;
      if (impressionIO) impressionIO.unobserve(el);
      var key = impressionKey(el.__bbImpressionCtx);
      if (!groups[key]) {
        groups[key] = { ctx: el.__bbImpressionCtx, items: [] };
        order.push(key);
      }
      groups[key].items.push(item);
    }
    for (var g = 0; g < order.length; g++) {
      var group = groups[order[g]];
      pushVisibleList(group.ctx, group.items);
    }
  }

  function onImpressionActivity() {
    markVisiblePending();
    scheduleImpressionFlush();
  }

  function bindImpressionActivity() {
    if (window.__bbImpressionActivity) return;
    window.__bbImpressionActivity = true;
    window.addEventListener('scroll', onImpressionActivity, true);
    window.addEventListener('resize', onImpressionActivity);
    document.addEventListener('touchend', onImpressionActivity, true);
    document.addEventListener(
      'transitionend',
      function (e) {
        var node = e.target;
        if (!node || !node.closest || !node.closest('.swiper, .slick-slider, .slick-list')) return;
        onImpressionActivity();
      },
      true,
    );
  }

  function getImpressionIO() {
    if (impressionIO || !('IntersectionObserver' in window)) return impressionIO;
    impressionIO = new IntersectionObserver(
      function (entries) {
        var hit = false;
        entries.forEach(function (en) {
          if (!en.isIntersecting || en.target.__bbImpressionDone || en.target.__bbImpressionPending)
            return;
          if (!elementIsVisible(en.target)) return;
          en.target.__bbImpressionPending = true;
          hit = true;
        });
        if (hit) scheduleImpressionFlush();
      },
      { threshold: [0, 0.25, 0.5, 0.75, 1] },
    );
    return impressionIO;
  }

  // build() runs when the gesture settles, so every product that entered together
  // shares one event. Nodes that fail to build (data not ready yet) stay watched.
  function observeImpression(el, ctx, build) {
    if (!el || el.__bbImpressionDone) return;
    el.__bbImpressionCtx = ctx;
    el.__bbBuildImpression = build;
    if (!el.__bbImpressionWatch) {
      el.__bbImpressionWatch = true;
      watchedImpressions.push(el);
      var io = getImpressionIO();
      if (io) io.observe(el);
      bindImpressionActivity();
    }
    scheduleImpressionFlush();
  }
  // Product id -> the list the shopper opened it from. Theme reads this for
  // view_item / view_cart / begin_checkout. The pixel reads a copy published below.
  var LIST_MAP_KEY = 'bb_ga4_item_lists';

  function productKey(id) {
    var s = String(id || '');
    var m = s.match(/(\d+)$/);
    return m ? m[1] : s;
  }

  function readListMap() {
    try {
      return JSON.parse(sessionStorage.getItem(LIST_MAP_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function publishListContext(itemId, listId, listName) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('bb_item_list_context', {
          item_id: itemId,
          item_list_id: listId || '',
          item_list_name: listName || '',
        });
      }
    } catch (e) {}
  }

  function rememberItemList(item, ctx) {
    if (!item || !ctx) return;
    var listId = ctx.id || '';
    var listName = ctx.name || '';
    if (!listId && !listName) return;
    var key = productKey(item.item_id);
    if (!key) return;
    var map = readListMap();
    if (map[key]) delete map[key];
    map[key] = { item_list_id: listId, item_list_name: listName };
    var keys = Object.keys(map);
    while (keys.length > 40) {
      delete map[keys.shift()];
    }
    try {
      sessionStorage.setItem(LIST_MAP_KEY, JSON.stringify(map));
    } catch (e) {}
    publishListContext(key, listId, listName);
  }

  function listFromUrl() {
    try {
      var u = new URL(window.location.href);
      var id = u.searchParams.get('item_list_id') || '';
      var name = u.searchParams.get('item_list_name') || '';
      if (!id && !name) return null;
      return { item_list_id: id, item_list_name: name };
    } catch (e) {
      return null;
    }
  }

  function applyItemList(item, usePageUrl) {
    if (!item) return item;
    var key = productKey(item.item_id);
    var entry = (key && readListMap()[key]) || (usePageUrl ? listFromUrl() : null);
    if (!entry) return item;
    if (entry.item_list_id) item.item_list_id = entry.item_list_id;
    if (entry.item_list_name) item.item_list_name = entry.item_list_name;
    return item;
  }

  function stampListOnLink(link, ctx) {
    if (!link || !ctx || (!ctx.id && !ctx.name)) return;
    try {
      var u = new URL(link.getAttribute('href'), window.location.origin);
      if (ctx.id) u.searchParams.set('item_list_id', ctx.id);
      if (ctx.name) u.searchParams.set('item_list_name', ctx.name);
      link.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function selectItem(ctx, item, link) {
    // Sliders (Swiper loop, Slick clones) can dispatch two clicks for one tap.
    // Drop the repeat for the same list + product. Window-scoped so a second
    // copy of this script cannot push the duplicate either.
    var key = String((ctx && ctx.id) || '') + '|' + String((item && item.item_id) || '');
    var now = Date.now();
    var prev = window.__bbLastSelectItem;
    if (prev && prev.key === key && now - prev.at < 800) return;
    window.__bbLastSelectItem = { key: key, at: now };
    rememberItemList(item, ctx);
    stampListOnLink(link, ctx);
    pushEcommerce('select_item', {
      item_list_id: ctx.id,
      item_list_name: ctx.name,
      currency: CURRENCY,
      items: [item],
    });
  }

  function listContext(el) {
    var h = el.closest && el.closest('[data-ga-list-name]');
    if (h) {
      var name = h.getAttribute('data-ga-list-name') || '';
      return { id: h.getAttribute('data-ga-list-id') || handleize(name), name: name };
    }
    return CONFIG.list && (CONFIG.list.id || CONFIG.list.name) ? CONFIG.list : { id: '', name: '' };
  }

  // item_id = Shopify product_id everywhere (consistent funnel; Boost SD PLP has no SKU).
  function lineToItem(l, qty) {
    var item = {
      item_id: String(l.product_id || l.variant_id || l.id || ''),
      item_name: l.product_title || l.title || '',
      item_brand: l.vendor || 'Brandon Blackwood',
      price: round2((l.final_price != null ? l.final_price : l.price || 0) / 100),
      quantity: qty != null ? qty : l.quantity,
    };
    if (l.variant_title) item.item_variant = l.variant_title;
    if (l.product_type) item.item_category = l.product_type;
    applyItemList(item);
    return item;
  }

  function isRouteLine(l) {
    return /(shipping|package)\s+protection/i.test(l.product_title || l.title || '');
  }

  function discountCode(cart) {
    var a = cart && (cart.discount_applications || cart.cart_level_discount_applications);
    return a && a.length ? a[0].code || a[0].title || '' : '';
  }

  // page_viewed
  function firePageView() {
    push({
      event: 'page_viewed',
      page_type: CONFIG.page_type || '',
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }

  /* view_item_list / select_item — theme .product-card grids (sliders, PDP recs, and
     Boost SSR first load). Boost SD PLP is handled separately below. */
  function itemFromCard(card, index) {
    var data;
    try {
      data = JSON.parse(card.getAttribute('data-ga4-item'));
    } catch (e) {}
    if (!data) {
      // Fallback: scrape (Boost client-rendered cards lack data-ga4-item).
      data = {};
      var t = card.querySelector('.product-card__title');
      var pr = card.querySelector('.product-card__price');
      var link = card.querySelector('a[href*="/products/"]');
      if (t) data.item_name = txt(t);
      if (pr) {
        var n = parseFloat((pr.textContent || '').replace(/[^0-9.]/g, ''));
        if (!isNaN(n)) data.price = n;
      }
      if (link) {
        var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) data.item_id = m[1];
      }
    }
    var item = {};
    ['item_id', 'item_name', 'item_brand', 'item_category', 'item_variant', 'price'].forEach(
      function (k) {
        if (data[k] != null && data[k] !== '') item[k] = data[k];
      },
    );
    if (index != null) item.index = index;
    return item;
  }

  function cardListIndex(root, card) {
    var all = root.querySelectorAll('.product-card');
    var real = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].closest('.swiper-slide-duplicate, .slick-cloned')) continue;
      real.push(all[i]);
    }
    var at = real.indexOf(card);
    if (at >= 0) return at + 1;
    var wanted = '';
    try {
      var data = JSON.parse(card.getAttribute('data-ga4-item') || '');
      wanted = data && data.item_id != null ? String(data.item_id) : '';
    } catch (e) {}
    if (wanted) {
      for (var j = 0; j < real.length; j++) {
        try {
          var parsed = JSON.parse(real[j].getAttribute('data-ga4-item') || '');
          if (parsed && String(parsed.item_id) === wanted) return j + 1;
        } catch (e2) {}
      }
    }
    return nodeIndex(all, card);
  }

  function watchProductCards(root) {
    if (!root) return;
    var cards = root.querySelectorAll('.product-card');
    for (var i = 0; i < cards.length; i++) {
      observeImpression(cards[i], listContext(root), function (card) {
        return itemFromCard(card, cardListIndex(root, card));
      });
    }
  }

  function observeListMutations(root) {
    if (root.__bbListWatch) return;
    root.__bbListWatch = true;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        watchProductCards(root);
      }, 200);
    }).observe(root, { childList: true, subtree: true });
  }

  /* Boost PFS integration: boost-pfs-filter.js afterRender hook calls onBoostRender with
     the full product array. We stamp cards (so select_item matches). Visibility
     tracking then reports only the products on screen. */

  function boostFirstVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i] && vs[i].available) return vs[i];
    return vs[0] || {};
  }

  // NOTE: Boost prices are already in major units (dollars) — do NOT divide by 100.
  function boostItemToGa4(p, i) {
    var v = boostFirstVariant(p);
    var item = {
      item_id: String(p.id || ''),
      item_name: p.title || '',
      item_brand: p.vendor || 'Brandon Blackwood',
      item_category: p.type || '',
      price: round2(p.price_min != null ? p.price_min : v.price || 0),
    };
    if (v.title && v.title !== 'Default Title') item.item_variant = v.title;
    if (i != null) item.index = i + 1;
    if (!item.item_name) delete item.item_name;
    if (!item.item_category) delete item.item_category;
    return item;
  }

  function onBoostRender(products) {
    if (!products || !products.length) return;
    var container = document.querySelector('.boost-pfs-filter-products');
    if (!container) return;
    var cards = container.querySelectorAll('.product-card');
    var limit = Math.min(cards.length, products.length);
    for (var j = 0; j < limit; j++) {
      if (!cards[j].getAttribute('data-ga4-item')) {
        try {
          cards[j].setAttribute('data-ga4-item', JSON.stringify(boostItemToGa4(products[j], j)));
        } catch (e) {}
      }
    }
    watchProductCards(container);
  }

  function initListing() {
    var seen = [];
    function addRoot(n) {
      if (!n || seen.indexOf(n) >= 0) return;
      seen.push(n);
      watchProductCards(n);
      observeListMutations(n);
    }
    document.querySelectorAll('[data-ga-list-name]').forEach(function (n) {
      addRoot(n);
    });
    document.querySelectorAll('.boost-pfs-filter-products').forEach(function (n) {
      if (!n.closest('[data-ga-list-name]')) addRoot(n);
    });

    onClick(function (e) {
      var link = e.target.closest && e.target.closest('.product-card a[href*="/products/"]');
      if (!link) return;
      var card = link.closest('.product-card');
      if (!card) return;
      // Boost lists have their own select_item handlers. Skipping here stops one
      // click from pushing the event twice when both markups wrap the same link.
      if (card.closest('.boost-sd__product-item, .boost-sd__recommendation')) return;
      var root =
        card.closest('[data-ga-list-name]') ||
        card.closest('.boost-pfs-filter-products') ||
        card.parentElement;
      var item = itemFromCard(
        card,
        root ? nodeIndex(root.querySelectorAll('.product-card'), card) : 1,
      );
      selectItem(listContext(card), item, link);
    });
  }

  /* Boost SD (AI Search & Discovery) — the live collection/search PLP, client-rendered as
     <ul.boost-sd__product-list><li.boost-sd__product-item> with a data-product JSON. */
  function boostSDContext() {
    return CONFIG.list && (CONFIG.list.id || CONFIG.list.name) ? CONFIG.list : { id: '', name: '' };
  }

  function boostSDItem(li, index) {
    var data;
    try {
      data = JSON.parse(li.getAttribute('data-product'));
    } catch (e) {}

    var titleEl = li.querySelector('.boost-sd__product-title');
    var link = li.querySelector('a.boost-sd__product-link, a[href*="/products/"]');

    var pid = li.getAttribute('data-product-id') || (data && (data.productId || data.handle)) || '';
    if (!pid && link) {
      var hm = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (hm) pid = hm[1];
    }
    if (!pid) return null;

    var item = { item_id: String(pid) };
    var name = titleEl ? txt(titleEl) : link ? (link.getAttribute('aria-label') || '').trim() : '';
    if (name) item.item_name = name;
    item.item_brand = 'Brandon Blackwood';

    // item_category = Boost's own category field (whatever it provides, e.g. "Sizes 35-44").
    if (data && data.category) item.item_category = String(data.category).trim();
    // item_variant = colour option value (matches the SSR/spec convention).
    var opts = (data && data.options_with_values) || [];
    var opt = null;
    for (var o = 0; o < opts.length; o++) {
      var nm = (opts[o].original_name || opts[o].name || opts[o].label || '').toLowerCase();
      if (nm === 'color' || nm === 'colour') {
        opt = opts[o];
        break;
      }
    }
    opt = opt || opts[0];
    if (opt && opt.values && opt.values[0]) item.item_variant = (opt.values[0].title || '').trim();

    // Boost SD priceMin is already in major units (matches the visible price and the
    // scrape fallback below) — do NOT divide by 100.
    if (data && data.priceMin) {
      var pr = Number(data.priceMin);
      if (!isNaN(pr)) item.price = round2(pr);
    } else {
      var priceEl = li.querySelector('.boost-sd__product-price');
      if (priceEl) {
        var ps = parseFloat((priceEl.textContent || '').replace(/[^0-9.]/g, ''));
        if (!isNaN(ps)) item.price = round2(ps);
      }
    }
    if (index != null) item.index = index;
    return item;
  }

  function watchBoostSDItems(list) {
    if (!list) return;
    var nodes = list.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < nodes.length; i++) {
      observeImpression(nodes[i], boostSDContext(), function (li) {
        var parent = li.closest('ul.boost-sd__product-list');
        var index = parent ? nodeIndex(parent.querySelectorAll('.boost-sd__product-item'), li) : 1;
        return boostSDItem(li, index);
      });
    }
  }

  function initBoostSD() {
    if (CONFIG.page_type !== 'collection' && CONFIG.page_type !== 'search') return;
    // Observe document.body (not just .boost-sd-container, which Boost injects late).
    var scope = document.body;
    function scan() {
      // First: a throw below must not suppress custom_search. fireSearch() only fires once.
      var count = boostResultCount();
      if (count != null) fireSearch(count);
      var list = document.querySelector('ul.boost-sd__product-list');
      if (list) watchBoostSDItems(list);
    }
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 350);
    }).observe(scope, { childList: true, subtree: true });
    // scan() only attaches observers. Already-seen products are not reported again.
    [400, 900, 1800, 3000, 5000].forEach(function (d) {
      setTimeout(scan, d);
    });
    scan();

    onClick(function (e) {
      var link =
        e.target.closest && e.target.closest('.boost-sd__product-item a[href*="/products/"]');
      if (!link) return;
      var li = link.closest('.boost-sd__product-item');
      if (!li || li.closest('.boost-sd__recommendation')) return;
      var list = li.closest('ul.boost-sd__product-list');
      var item = boostSDItem(
        li,
        list ? nodeIndex(list.querySelectorAll('.boost-sd__product-item'), li) : 1,
      );
      if (item) selectItem(boostSDContext(), item, link);
    });
  }

  /* PDP Boost recommendations (Similar Items, Recently Viewed).
     Fire only the slides actually on screen. Later slides fire when they scroll
     or slide into view. Already reported products are skipped. */
  function recommendationListContext(widget) {
    var titleEl = widget.querySelector('.boost-sd__recommendation-title-text');
    var title = txt(titleEl).toLowerCase();
    if (title === 'similar items' || title === 'similiar items') {
      return { id: 'similar-items', name: 'Similar Items' };
    }
    if (title === 'recently viewed') {
      return { id: 'recently-viewed', name: 'Recently Viewed' };
    }
    var widgetId = widget.id || '';
    if (widgetId === 'productpage-860088') return { id: 'similar-items', name: 'Similar Items' };
    if (widgetId === 'productpage-182676')
      return { id: 'recently-viewed', name: 'Recently Viewed' };
    return null;
  }

  function recommendationProductNodes(widget) {
    var items = widget.querySelectorAll('.boost-sd__product-item');
    var out = [];
    var seen = {};
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.closest('.slick-cloned')) continue;
      var id = li.getAttribute('data-product-id') || '';
      if (id && seen[id]) continue;
      if (id) seen[id] = 1;
      out.push(li);
    }
    return out;
  }

  function toRecommendationItem(li, index) {
    var item = boostSDItem(li, index);
    if (!item) return null;
    if (/^\d+$/.test(String(item.item_id))) item.item_id = Number(item.item_id);
    item.item_brand = 'Brandon Blackwood New York';
    return item;
  }

  function recommendationItemFromClick(widget, li) {
    var nodes = recommendationProductNodes(widget);
    var id = li.getAttribute('data-product-id') || '';
    var source = li;
    var index = 1;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i] === li || (id && nodes[i].getAttribute('data-product-id') === id)) {
        source = nodes[i];
        index = i + 1;
        break;
      }
    }
    return toRecommendationItem(source, index);
  }

  function watchRecommendationItems(widget) {
    var ctx = recommendationListContext(widget);
    if (!ctx) return;
    var nodes = widget.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < nodes.length; i++) {
      observeImpression(nodes[i], ctx, function (li) {
        return recommendationItemFromClick(widget, li);
      });
    }
  }

  function initBoostRecommendations() {
    if (CONFIG.page_type !== 'product') return;

    function scan() {
      var widgets = document.querySelectorAll('.boost-sd__recommendation');
      for (var i = 0; i < widgets.length; i++) {
        if (!recommendationListContext(widgets[i])) continue;
        watchRecommendationItems(widgets[i]);
      }
    }

    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 350);
    }).observe(document.body, { childList: true, subtree: true });
    [400, 900, 1800, 3000, 5000].forEach(function (d) {
      setTimeout(scan, d);
    });
    scan();

    onClick(function (e) {
      var link =
        e.target.closest &&
        e.target.closest('.boost-sd__recommendation .boost-sd__product-item a[href*="/products/"]');
      if (!link) return;
      var li = link.closest('.boost-sd__product-item');
      var widget = li && li.closest('.boost-sd__recommendation');
      if (!li || !widget) return;
      var ctx = recommendationListContext(widget);
      if (!ctx) return;
      var item = recommendationItemFromClick(widget, li);
      if (item) selectItem(ctx, item, link);
    });
  }

  // view_item
  function fireViewItem() {
    var el = CONFIG.page_type === 'product' && document.getElementById('bb-ga4-view-item');
    if (!el) return;
    try {
      var data = JSON.parse(el.textContent);
      (data.items || []).forEach(function (item) {
        var fromUrl = !readListMap()[productKey(item.item_id)] && listFromUrl();
        applyItemList(item, true);
        if (fromUrl) rememberItemList(item, { id: item.item_list_id, name: item.item_list_name });
        else if (item.item_list_id || item.item_list_name) {
          publishListContext(productKey(item.item_id), item.item_list_id, item.item_list_name);
        }
      });
      pushEcommerce('view_item', data);
    } catch (e) {}
  }

  /* remove_from_cart / view_cart / begin_checkout — Liquid Ajax Cart.
     add_to_cart is handled in the Customer Events custom pixel (not theme). */
  function itemsFromCart(cart) {
    return (cart.items || []).map(function (l) {
      return lineToItem(l);
    });
  }
  function indexByKey(cart) {
    var m = {};
    (cart.items || []).forEach(function (l) {
      m[l.key] = l;
    });
    return m;
  }
  function fireViewCart(cart) {
    if (!cart || !cart.item_count) return;
    pushEcommerce('view_cart', {
      currency: CURRENCY,
      value: round2((cart.total_price || 0) / 100),
      items: itemsFromCart(cart),
    });
  }

  function initCart() {
    var prev = null;

    // Push remove_from_cart for each cart line whose quantity went down.
    function reportQuantityDecreases(before, after) {
      Object.keys(before).forEach(function (key) {
        var removed = before[key].quantity - (after[key] ? after[key].quantity : 0);
        if (removed > 0) {
          var item = lineToItem(before[key], removed);
          pushEcommerce('remove_from_cart', {
            currency: CURRENCY,
            value: round2(item.price * removed),
            items: [item],
          });
        }
      });
    }
    function handleState(cart) {
      if (!cart) return;
      if (prev) {
        reportQuantityDecreases(indexByKey(prev), indexByKey(cart));
      }
      prev = cart; // first call just seeds the baseline
      window.__bbCart = cart;
    }
    function subscribe() {
      var laj = window.liquidAjaxCart;
      if (!laj || typeof laj.subscribeToCartStateUpdate !== 'function') return false;
      laj.subscribeToCartStateUpdate(function (state) {
        handleState(state && state.cart ? state.cart : state);
      });
      return true;
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        if (!prev) prev = c;
        window.__bbCart = c;
        if (CONFIG.page_type === 'cart') fireViewCart(c);
      })
      .catch(function () {});

    if (!subscribe()) {
      var tries = 0;
      var iv = setInterval(function () {
        if (subscribe() || ++tries > 50) clearInterval(iv);
      }, 100);
    }

    onClick(function (e) {
      var btn =
        e.target.closest &&
        e.target.closest(
          '[name="checkout"], .cart__view, a[href*="/checkout"], .route-continue-without-coverage-link',
        );
      if (!btn) return;
      var cart = window.__bbCart;
      if (!cart || !cart.item_count) return;
      // Fire once per checkout intent (guards duplicate/re-dispatched clicks); window-scoped.
      if (Date.now() - (window.__bbLastBeginCheckout || 0) < 2000) return;
      window.__bbLastBeginCheckout = Date.now();

      var line = document.querySelector('[data-route-static-line]');
      var cents = btn.closest('.route-continue-without-coverage-link')
        ? 0
        : (line && parseInt(line.getAttribute('data-route-cents'), 10)) || 0;

      var value = cart.total_price || 0;
      var items = [];
      (cart.items || []).forEach(function (l) {
        if (isRouteLine(l)) value -= l.final_line_price || 0;
        else items.push(lineToItem(l));
      });
      if (cents) {
        value += cents;
        items.push({
          item_id: 'shipping_protection_route',
          item_name: 'Shipping Protection by Route',
          item_brand: 'Route',
          item_category: 'Shipping Protection',
          price: round2(cents / 100),
          quantity: 1,
        });
      }

      var eco = {
        currency: CURRENCY,
        value: round2(value / 100),
        shipping_protection: cents ? 'yes' : 'no',
        items: items,
      };
      var code = discountCode(cart);
      if (code) eco.coupon = code;
      pushEcommerce('begin_checkout', eco);
    });
  }

  /* Boost SD renders the search results. Boost publishes its real total on #results-number; null = it hasn't rendered yet. */
  function boostResultCount() {
    var el = document.querySelector('[data-total-product]');
    if (!el) return null;
    var n = parseInt(el.getAttribute('data-total-product'), 10);
    return isNaN(n) ? null : n;
  }

  /* custom_search - once per unique search this session */
  var searchFired = false;
  function fireSearch(count) {
    if (searchFired) return;
    if (CONFIG.page_type !== 'search' || !CONFIG.search || !CONFIG.search.term) return;
    searchFired = true;
    var key = 'bb_ga4_search:' + location.pathname + location.search;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {}
    push({
      event: 'custom_search',
      search_term: CONFIG.search.term,
      search_results_count: count,
    });
  }

  function initHeaderMenu() {
    var ICONS = { search: 'search icon', account: 'profile icon' };
    onClick(function (e) {
      var a = closestA(e);
      if (!a) return;
      var li = a.closest('.section-header__list-item');
      // Cart icon is excluded from header_menu_click; skip it entirely so it doesn't
      // fall through to the generic menu-list branch below and still fire.
      if (li && li.getAttribute('data-name') === 'cart') return;
      var icon = li && ICONS[li.getAttribute('data-name')];
      if (icon) {
        push({
          event: 'header_menu_click',
          main_menu: icon,
          sub_menu: '-',
          click_text: '-',
          click_url: '-',
        });
        return;
      }
      // Studio nav has its own DOM (.nav_link_box > a, plain <li>); use the block's configured
      // label for main_menu instead of falling back to the clicked link's text.
      var studioNav = a.closest('.studio_navigation');
      if (studioNav) {
        var topUl = studioNav.querySelector('ul');
        var topLi = a.closest('li');
        while (topLi && topLi.parentNode !== topUl) {
          topLi =
            topLi.parentNode && topLi.parentNode.closest ? topLi.parentNode.closest('li') : null;
        }
        var parentLink = topLi && topLi.querySelector('.nav_link_box a');
        var studioText = txt(a);
        push({
          event: 'header_menu_click',
          main_menu: studioNav.getAttribute('data-ga-main-menu') || '-',
          sub_menu: studioText || '-',
          click_text: studioText,
          click_url: a.getAttribute('href'),
        });
        return;
      }
      if (!a.closest('.section-header__list, .mobile_menu, .desktop_menu')) return;

      var mainLink = li && li.querySelector('.section-header__list-item-link a');
      var accordionLabel = li && li.querySelector('.nav-accordion__trigger-label');
      var drawerTitle = li && li.querySelector('.section-header__dropdown-header-header-title');
      var mainMenu = txt(accordionLabel) || txt(mainLink) || txt(drawerTitle) || '';
      // Prefer dedicated text spans so badges (e.g. COLLAB) are not included.
      var linkLabel = a.querySelector(
        '.mega-menu__column-link-text, .mega-menu__card-title, .mega-menu__campaign-cta',
      );
      var clickText = txt(linkLabel) || txt(a);
      var isTopLevel = !!(mainLink && a === mainLink);
      push({
        event: 'header_menu_click',
        main_menu: mainMenu || clickText,
        sub_menu: isTopLevel ? '-' : clickText, // '-' on a top-level click
        click_text: clickText,
        click_url: a.getAttribute('href'),
      });
    });
  }

  function initFooterMenu() {
    onClick(function (e) {
      var a = closestA(e);
      if (!a || !a.closest('.section-footer__link-list, .section-footer__bottom-block-list'))
        return;
      var href = a.getAttribute('href');
      if (!href || href === '#') return; // skip non-navigational (e.g. accessibility trigger)
      var box = a.closest('.section-footer__link-list-box');
      push({
        event: 'footer_menu_click',
        main_menu: txt(box && box.querySelector('.section-footer__link-list-title')) || '-',
        sub_menu: '-',
        click_text: txt(a),
        click_url: href,
      });
    });
  }

  // cta_click — opt-in via [data-ga-cta] attributes.
  function initCtaClicks() {
    onClick(function (e) {
      var el = e.target.closest && e.target.closest('[data-ga-cta]');
      if (!el) return;
      push({
        event: 'cta_click',
        section_name: el.getAttribute('data-ga-cta-section') || '',
        cta_position: el.getAttribute('data-ga-cta-position') || '',
        cta_text: el.getAttribute('data-ga-cta-text') || txt(el),
        click_url: el.getAttribute('href') || el.getAttribute('data-ga-cta-url') || '',
        page_url: window.location.pathname,
      });
    });
  }

  // newsletter_subscription — footer embed lives in .custom-klaviyo-form-wrapper; else it's the popup.
  // Popups opened by a theme trigger, shared with initKlaviyoPopups: formId -> { prefix, source, ... }.
  var klaviyoActivePopups = {};

  // Klaviyo fires 'submit' again on later steps (phone, code), so report it once per form open.
  // Black Friday popups report their own black_friday_email_submit instead.
  function initNewsletter() {
    var sent = {};
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail) return;
      if (e.detail.type === 'open' || e.detail.type === 'embedOpen') {
        delete sent[e.detail.formId];
        return;
      }
      if (e.detail.type !== 'submit') return;
      var popup = klaviyoActivePopups[e.detail.formId];
      if (popup && popup.prefix !== 'newsletter') return;
      if (sent[e.detail.formId]) return;
      sent[e.detail.formId] = true;
      var el = document.querySelector('.klaviyo-form-' + e.detail.formId);
      var location =
        el && el.closest('.custom-klaviyo-form-wrapper') ? 'footer_newsletter' : 'popup_newsletter';
      push({ event: 'newsletter_subscription', method: 'email', form_location: location });
    });
  }

  // Klaviyo popup funnel — only for popups opened by a theme trigger (announcement bar link or
  // BB Banner button; see js-klaviyo-form-trigger.js). Black Friday collection popups get their own
  // event names. Never pushes form values (email / phone).
  //   <prefix>_popup_open, <prefix>_email_submit (black_friday only; newsletter uses
  //   newsletter_subscription above), <prefix>_phone_submit, <prefix>_otp_submit, <prefix>_popup_close
  function initKlaviyoPopups() {
    var TRIGGER_WINDOW_MS = 15000;
    var CLOSE_CLICK_WINDOW_MS = 3000;
    var active = klaviyoActivePopups; // formId -> { prefix, source, phoneSteps, emailSent }
    var lastCloseClick = null;

    function popupPrefix(source) {
      var path = window.location.pathname.replace(/\/+$/, '');
      if (source === 'bb_banner' && /\/collections\/black-friday$/.test(path))
        return 'black_friday';
      return 'newsletter';
    }

    function basePayload(formId, popup) {
      return {
        form_id: formId,
        popup_source: popup.source,
        page_path: window.location.pathname,
      };
    }

    function send(name, formId, popup, extra) {
      var payload = basePayload(formId, popup);
      payload.event = popup.prefix + '_' + name;
      for (var k in extra) payload[k] = extra[k];
      push(payload);
    }

    function hasKey(meta, re) {
      if (!meta) return false;
      for (var k in meta) {
        if (re.test(k) && meta[k] !== '' && meta[k] != null) return true;
      }
      return false;
    }

    // "No thanks" vs the X icon both end in Klaviyo's 'close' event; remember which was clicked.
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var btn = t.closest('button, a, [role="button"]');
        if (!btn) return;
        var label = (btn.getAttribute('aria-label') || '').toLowerCase();
        var text = txt(btn).toLowerCase();
        var method = '';
        if (/no,? thanks/.test(text) || /no,? thanks/.test(label)) method = 'no_thanks';
        else if (/close/.test(label)) method = 'close_icon';
        if (method) lastCloseClick = { method: method, time: Date.now() };
      },
      true,
    );

    window.addEventListener('klaviyoForms', function (e) {
      var d = e.detail;
      if (!d || !d.formId) return;
      var formId = d.formId;

      if (d.type === 'open') {
        var trig = window.__bbKlaviyoLastTrigger;
        if (!trig || trig.formId !== formId || Date.now() - trig.time > TRIGGER_WINDOW_MS) return;
        window.__bbKlaviyoLastTrigger = null;
        active[formId] = {
          prefix: popupPrefix(trig.source),
          source: trig.source,
          phoneSteps: 0,
          emailSent: false,
        };
        send('popup_open', formId, active[formId], {});
        return;
      }

      var popup = active[formId];
      if (!popup) return;

      if (d.type === 'submit') {
        // Email step (Klaviyo repeats 'submit' on later steps, so only the first counts).
        // Announcement bar already reports this as newsletter_subscription.
        if (popup.emailSent) return;
        popup.emailSent = true;
        if (popup.prefix !== 'newsletter') send('email_submit', formId, popup, { method: 'email' });
        return;
      }

      if (d.type === 'stepSubmit') {
        var meta = d.metaData || {};
        var isOtp = hasKey(meta, /otp|one[_-]?time|verification|code/i);
        var hasPhone = hasKey(meta, /phone/i);
        if (!isOtp && !hasPhone) return; // email-only step, already covered by submit
        // Klaviyo re-sends the phone number on the code step, so the second phone step is the OTP.
        if (!isOtp) {
          popup.phoneSteps += 1;
          isOtp = popup.phoneSteps > 1;
        }
        send(isOtp ? 'otp_submit' : 'phone_submit', formId, popup, { method: 'sms' });
        return;
      }

      if (d.type === 'close') {
        var method = 'other';
        if (lastCloseClick && Date.now() - lastCloseClick.time < CLOSE_CLICK_WINDOW_MS)
          method = lastCloseClick.method;
        lastCloseClick = null;
        send('popup_close', formId, popup, { close_method: method });
        delete active[formId];
      }
    });
  }

  // app_download_click
  function initMiscClicks() {
    onClick(function (e) {
      var a =
        e.target.closest &&
        e.target.closest(
          '[data-ga-app-download], a[href*="apps.apple.com"], a[href*="play.google.com"]',
        );
      if (a) {
        var href = a.getAttribute('href') || '';
        var platform =
          a.getAttribute('data-ga-app-platform') ||
          (/apple/i.test(href) ? 'ios' : /google/i.test(href) ? 'android' : '');
        if (!platform) {
          var alt = (a.querySelector('img') || {}).alt || '';
          platform = /app store/i.test(alt) ? 'ios' : /google play/i.test(alt) ? 'android' : '';
        }
        push({
          event: 'app_download_click',
          app_platform: platform || '',
          click_url: href,
          placement: a.getAttribute('data-ga-placement') || 'footer',
        });
      }
    });
  }

  // chat_widget - Gorgias floating chat. The launcher lives in Gorgias' own iframe, so we can't
  // catch clicks; hook the widget's own open/close events instead (fired once it finishes loading).
  function initChatWidget() {
    var initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise(function (resolve) {
          window.addEventListener('gorgias-widget-loaded', function () {
            resolve();
          });
        });

    initGorgiasChatPromise.then(function () {
      if (!window.GorgiasChat || typeof window.GorgiasChat.on !== 'function') return;
      window.GorgiasChat.on('widget:opened', function () {
        push({
          event: 'chat_widget',
          widget_action: 'open',
          widget_name: 'chatbot_widget',
        });
      });
      window.GorgiasChat.on('widget:closed', function () {
        push({
          event: 'chat_widget',
          widget_action: 'close',
          widget_name: 'chatbot_widget',
        });
      });
    });
  }

  // Direct add to cart never opens the product, so select_item does not run.
  // Publish the list before Shopify's product_added_to_cart so the pixel can attach it.
  function rememberQuickAdd(node) {
    if (!node || !node.closest) return;
    var boostItem = node.closest('.boost-sd__product-item');
    var widget = boostItem && boostItem.closest('.boost-sd__recommendation');
    if (widget && boostItem) {
      var recCtx = recommendationListContext(widget);
      var recItem = recommendationItemFromClick(widget, boostItem);
      if (recCtx && recItem) rememberItemList(recItem, recCtx);
      return;
    }
    if (boostItem) {
      var list = boostItem.closest('ul.boost-sd__product-list');
      var bItem = boostSDItem(
        boostItem,
        list ? nodeIndex(list.querySelectorAll('.boost-sd__product-item'), boostItem) : 1,
      );
      if (bItem) rememberItemList(bItem, boostSDContext());
      return;
    }
    var card = node.closest('.product-card');
    if (!card) return;
    var root =
      card.closest('[data-ga-list-name]') ||
      card.closest('.boost-pfs-filter-products') ||
      card.parentElement;
    rememberItemList(itemFromCard(card, root ? cardListIndex(root, card) : 1), listContext(card));
  }

  function initQuickAddList() {
    onClick(function (e) {
      var btn =
        e.target.closest &&
        e.target.closest(
          '.boost-sd__btn-add-to-cart, .boost-sd__button--add-to-cart, .boost-sd__button--select-option, [data-add-to-cart-btn]',
        );
      if (!btn) return;
      rememberQuickAdd(btn);
    });
  }

  // Exposed synchronously so Boost's afterRender hook can reach it before first render.
  window.BBGa4 = window.BBGa4 || {};
  window.BBGa4.onBoostRender = onBoostRender;

  ready(function () {
    firePageView();
    fireViewItem();
    initListing();
    initBoostSD();
    initBoostRecommendations();
    initQuickAddList();
    initCart();
    initHeaderMenu();
    initFooterMenu();
    initCtaClicks();
    initNewsletter();
    initKlaviyoPopups();
    initMiscClicks();
    initChatWidget();
  });
})();
